var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6F0DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 14.0007H10.6667C10.8435 14.0007 11.0131 13.9304 11.1381 13.8054C11.2631 13.6804 11.3334 13.5108 11.3334 13.334C11.3334 13.1572 11.2631 12.9876 11.1381 12.8626C11.0131 12.7376 10.8435 12.6673 10.6667 12.6673H8.66671C8.4899 12.6673 8.32033 12.7376 8.1953 12.8626C8.07028 12.9876 8.00004 13.1572 8.00004 13.334C8.00004 13.5108 8.07028 13.6804 8.1953 13.8054C8.32033 13.9304 8.4899 14.0007 8.66671 14.0007ZM16.6667 7.33398H7.33337C6.80294 7.33398 6.29423 7.5447 5.91916 7.91977C5.54409 8.29484 5.33337 8.80355 5.33337 9.33398V15.334C5.33337 15.8644 5.54409 16.3731 5.91916 16.7482C6.29423 17.1233 6.80294 17.334 7.33337 17.334H16.6667C17.1971 17.334 17.7058 17.1233 18.0809 16.7482C18.456 16.3731 18.6667 15.8644 18.6667 15.334V9.33398C18.6667 8.80355 18.456 8.29484 18.0809 7.91977C17.7058 7.5447 17.1971 7.33398 16.6667 7.33398ZM17.3334 15.334C17.3334 15.5108 17.2631 15.6804 17.1381 15.8054C17.0131 15.9304 16.8435 16.0007 16.6667 16.0007H7.33337C7.15656 16.0007 6.98699 15.9304 6.86197 15.8054C6.73695 15.6804 6.66671 15.5108 6.66671 15.334V11.334H17.3334V15.334ZM17.3334 10.0007H6.66671V9.33398C6.66671 9.15717 6.73695 8.9876 6.86197 8.86258C6.98699 8.73756 7.15656 8.66732 7.33337 8.66732H16.6667C16.8435 8.66732 17.0131 8.73756 17.1381 8.86258C17.2631 8.9876 17.3334 9.15717 17.3334 9.33398V10.0007Z",
    fill: "#D1B44D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.5f154d38c15cd7545bc906a72b2ce935.svg";
export { ForwardRef as ReactComponent };